import store from '@/store/index.js'

export default {
  onValidarCamposObligatorios(aCampos, oRespuesta) {
    let bError = false
    let sMensaje = ''
    aCampos.forEach(oItem => {
      if(oItem.obligatorio=='1'){
        if(oRespuesta[oItem.nombre] !== undefined){
          if(oRespuesta[oItem.nombre] == null || oRespuesta[oItem.nombre] == '' || oRespuesta[oItem.nombre] === undefined){
            //if(oItem.tipo=='anexos'){
              
            //}else{
              bError = true
              sMensaje += '- ' + 'El campo &&&& no ha sido diligenciado.'.replace('&&&&','<b>' + oItem.label + '</b>')+ ' <br>'
            //}
          }
        }else{
          bError = true
          sMensaje += '- ' + 'El campo &&&& no ha sido diligenciado.'.replace('&&&&','<b>' + oItem.label + '</b>')+ ' <br>'
        }

        const sReglas = this.onValidarProps('aReglas', '', oItem.Condicion)
        if(sReglas) {
          const aReglas = sReglas.split(';')
          aReglas.forEach(sRegla => {
            let sVal = null
            const aReglaAsig = sRegla.split(',');
            switch (aReglaAsig[0]) {
              case 'onValNoEspaciosCaracteres':
                sVal= this.onValNoEspaciosCaracteres(oRespuesta[oItem.nombre])
              break;
              case 'onValMinCaracteres': {
                const nMin = (aReglaAsig[1]) ? parseInt(aReglaAsig[1]) : 10
                sVal= this.onValMinCaracteres(oRespuesta[oItem.nombre],nMin)
              }
              break;
            
              default:
                break;
            }
            if(typeof sVal === 'string'){
              bError = true
              sMensaje += '- ' + 'Campo ' +oItem.label +':' + sVal + '<br>'
            }
          })
        }
      }
    })

    return {
      bError: bError,
      sMensaje: sMensaje
    }
  },

  /*
   Esta funcion valida el estado de los campos para un formulario, si existen errores, devolvera un objeto
   que contiene 'bError' que indica si existen errores con true o false y un array 'aMensajes' con cada uno de los errores por campo
  */
  onValidarCamposForm(aCampos, oRespuesta) {
    let bError = false
    let aMensajes = []
    aCampos.forEach(oItem => {
      if(oItem.obligatorio=='1'){
        if(oRespuesta[oItem.nombre] !== undefined){
          if(oRespuesta[oItem.nombre] == null || oRespuesta[oItem.nombre] == '' || oRespuesta[oItem.nombre] === undefined){
            //if(oItem.tipo=='anexos'){
              
            //}else{
              bError = true
              aMensajes.push('El campo &&&& no ha sido diligenciado.'.replace('&&&&',oItem.label))
            //}
          }
        }else{
          bError = true
          aMensajes.push('El campo &&&& no ha sido diligenciado.'.replace('&&&&',oItem.label))
        }

        const sReglas = this.onValidarProps('aReglas', '', oItem.Condicion)
        if(sReglas) {
          const aReglas = sReglas.split(';')
          aReglas.forEach(sRegla => {
            let sVal = null
            const aReglaAsig = sRegla.split(',');
            switch (aReglaAsig[0]) {
              case 'onValNoEspaciosCaracteres':
                sVal= this.onValNoEspaciosCaracteres(oRespuesta[oItem.nombre])
              break;
              case 'onValMinCaracteres': {
                const nMin = (aReglaAsig[1]) ? parseInt(aReglaAsig[1]) : 10
                sVal= this.onValMinCaracteres(oRespuesta[oItem.nombre],nMin)
              }
              break;
              case 'onValidarExpresion': {
                sVal= this.onValExpresion(oRespuesta[oItem.nombre], aReglaAsig[1])
              }
              
              break;
            
              default:
                break;
            }
            if(typeof sVal === 'string'){
              bError = true
              aMensajes.push('Campo ' +oItem.label +': ' + sVal)
            }
          })
        }
      }
    })

    return {
      bError: bError,
      aMensajes: aMensajes
    }
  },

  onValNoEspaciosCaracteres(v){
    return /^[a-zA-Z0-9.]+$/.test(v) || store.state.jsIdioma.oEquivalencias.msgSinEspaciosCarecteresEspeciales
  },
  onValMinCaracteres(v,nMin){
    if(v){
      return v.length >= nMin  || store.state.jsIdioma.oEquivalencias.lblMinimoCaracteres.replace('###', nMin)
    }else{
      return 0 >= nMin  || store.state.jsIdioma.oEquivalencias.lblMinimoCaracteres.replace('###', nMin)
    }
  },
  onValidarProps (sIndex, ValorDefecto, sCondicion) {
    if(sCondicion === null || sCondicion === undefined) return ValorDefecto
    const aParametros = sCondicion.includes('|') ? sCondicion.split('|') : [sCondicion]
    if  (aParametros.length > 0) {
      let sValor = ''
      aParametros.forEach(oItem => {
        if (oItem.includes(sIndex)) {
          const aParametroValor = oItem.split('=');
          sValor = (aParametroValor.length == 2) ? aParametroValor[1] : ValorDefecto
          return
        }
      })
      return sValor
    } else {
      return ValorDefecto
    }
  },
  onValExpresion(sTexto, sTipo){
    let resutlado = false;
    switch (sTipo) {
      case 'url':{
        resutlado =  /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/.test(sTexto) || store.state.jsIdioma.oEquivalencias.msgUrlNoValida
      }
        break;
      default:
        resutlado = false
        break;

    }
    return resutlado
  },

  onEncriptarValor(value){
    let sClaveNVR = '';
    for (let char of value) {
      let xorResult = char.charCodeAt(0) ^ 23;
      sClaveNVR += String.fromCharCode(xorResult);
    }
    return sClaveNVR
  }
}